import { ModuleBase, Stack, Text, Link, Box } from '@/components';
import { SideBySideModuleModel } from './SideBySideModule';
import { fadeInLeft, fadeInUp } from '@/animations';
import ArrowRightRound from '@/assets/arrowRightRound.svg';
import classNames from 'classnames';

const HomepageWhatsNext = (data: SideBySideModuleModel) => {
  const {
    props: { title, description, cards },
  } = data;

  return (
    <ModuleBase
      data={data}
      noPadding
      className="HomepageWhatsNext relative overflow-hidden pt-8 pb-8 md:pt-18 md:pb-0 xl:pt-[calc(72*100vh/911)]"
    >
      <Stack className="container flex h-full flex-col justify-around gap-6 md:justify-between md:gap-0">
        <div className="relative flex w-full flex-col justify-center md:justify-between lg:h-full">
          {description && (
            <Text
              animate
              animation={fadeInUp}
              dangerouslySetInnerHTML={{ __html: description }}
              className="text-style-h3 mx-auto flex w-full flex-col justify-center xl:text-[calc(48*100vh/911)] xl:leading-[calc(50*100vh/911)]"
            />
          )}
        </div>
        <div className="links-block flex w-full flex-col lg:flex-grow">
          <Box className="hidden w-full lg:block">
            <div className="-mb-px h-px w-full bg-black" />
          </Box>
          <div className="flex flex-col justify-between lg:flex-row">
            <div className="lg:w-1/2">
              {title && (
                <Text
                  dangerouslySetInnerHTML={{ __html: title }}
                  className="text-style-h2 mt-0 lg:mt-9 lg:!text-[75px] lg:leading-[75px]"
                />
              )}
            </div>
            <div className="[&_.module-base-dark_.border-from-bg]:! mt-5 flex flex-col md:mt-10 lg:mt-0 lg:w-1/2">
              {cards &&
                cards.map(
                  (card, index) =>
                    card.link && (
                      <Link
                        animate
                        animation={fadeInLeft}
                        key={index}
                        link={card.link}
                        className={classNames(
                          'color-from-bg group relative flex items-center justify-between gap-3 self-stretch py-[calc(16*100vh/911)] transition-colors duration-500 md:py-4 lg:px-7',
                          'xxl:px-[calc(36*100vh/911)] xxl:py-[calc(36*100vh/911)] xl:px-[calc(30*100vh/911)] xl:py-[calc(30*100vh/911)]',
                          'before-extended-bg hover:before:bg-yellow focus:before:bg-yellow lg:before:border-black',
                          index === 0
                            ? 'border-b lg:border-b-0 lg:before:border'
                            : index === cards.length - 1
                              ? 'lg:before:border-x'
                              : 'border-b lg:border-b-0 lg:before:border-x lg:before:border-b',
                        )}
                      >
                        {(card.title || card.text) && (
                          <div className="relative flex flex-col">
                            {card.title && <span className="text-style-h4 xl:text-[30px]">{card.title}</span>}
                          </div>
                        )}
                        <ArrowRightRound className="relative hidden h-8 w-8 shrink-0 opacity-0 transition-all duration-500 group-hover:opacity-100 group-focus:opacity-100 md:block md:h-10 md:w-10" />
                      </Link>
                    ),
                )}
            </div>
          </div>
        </div>
      </Stack>
    </ModuleBase>
  );
};

export default HomepageWhatsNext;
